export default {
    variants: {
        accountLink: {
            fontSize: 'md',
            fontWeight: 'normal'
        },
        accountInfo: {
            fontSize: 'sm',
            fontWeight: 'medium'
        },
        accountInfoSmall: {
            fontSize: 'xs'
        },
        accountStatus: {
            fontSize: 'md',
            fontWeight: 'bold'
        },
        barcodeText: {
            fontSize: 'xs',
            fontWeight: 'normal'
        },
        textWithSymbol: {
            fontSize: '10px',
            fontWeight: 'bold',
            _after: {
                color: 'progressPink.500',
                fontSize: '17px'
            }
        },
        promoBarText: {
            fontSize: 'xs',
            fontWeight: 'bold'
        },
        gcInfo: {
            fontSize: 'sm',
            fontWeight: 'semibold'
        },
        gcTitle: {
            fontSize: 'sm',
            fontWeight: 'bold'
        },
        leaveModalText: {
            fontSize: 'sm',
            fontWeight: 'normal'
        },
        smartSearchSubtitle: {
            fontSize: 'sm',
            fontWeight: 'normal',
            mb: 6
        },
        smartSearchTry: {
            fontSize: 'xs',
            fontWeight: 'normal',
            color: 'gray.700',
            mb: 3
        }
    }
}
